import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import MetaTags from 'react-meta-tags';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory from 'react-bootstrap-table2-filter';
import NumberFormat from 'react-number-format';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Collapse, Card, CardBody, CardHeader, Col, Container, Row, FormGroup, Alert } from 'reactstrap';

import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { getNewClients, getSelectedNewClients } from '../../store/stats/actions';
import { countryOptions } from '../../helpers/country_helper';
import MyExportCSV from '../../components/exportCSV';
import PageLoader from '../../components/Loaders/pageLoader';
import BarChartComp from './charts/barChart';
//Import Breadcrumb
import Breadcrumbs from '../../components/Breadcrumb';

class NewClientsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cards: [1],
      collapse: 1,
      year: '',
      month: '',
      manager: '',
      NewClientsListColumns: [
        {
          text: 'ID',
          dataField: 'id',
          sort: true,
          csvExport: false,
          editable: false,
          formatter: (cell, row, rowIndex) => rowIndex + 1,
          footer: ''
        },
        {
          text: 'Manager',
          dataField: 'manager',
          sort: true,
          hidden: false,
          editable: false,
          csvExport: true,
          csvFormatter: (cell, row, rowIndex) => row.manager.length !== 0 && row.manager.fname + ' ' + row.manager.sname,
          formatter: (cellContent, battle) => (
            <div className='slname-width'>
              <h5 className='font-size-16 mb-1'>
                {battle.manager ? (
                <span>
                  <div>
                    {!battle.manager.profilePic ? (
                    <div className='avatar-xs m-2 d-inline-block'>
                      <span className='avatar-title rounded-circle'>
                        {battle.manager.fname.charAt(0)}
                      </span>
                    </div>
                    ) : (<img className='rounded-circle avatar-xs m-2' src={battle.manager.profilePic} alt='profile pic'/>)}
                    <span>
                      {battle.manager.fname} {battle.manager.sname}
                    </span>
                  </div>
                </span>
                ) : null}
              </h5>
            </div>
            // <h5 className='font-size-16 mb-1'>
            //   {battle.manager.fname} {battle.manager.sname}
            // </h5>
          ),
          footer: ''
        },
        {
          text: "Client's Name",
          dataField: 'clientName',
          sort: true,
          hidden: false,
          editable: false,
          csvExport: true,
          formatter: (cellContent, battle) => (
            <div className='name-width'>
              <h5 className={battle.newClient === true ? 'font-size-16 mb-1 new-client-color' : 'font-size-16 mb-1'}>{battle.clientName}</h5>
            </div>
          ),
          footer: ''
        },
        {
          text: 'Invoice #',
          dataField: 'invoiceNo',
          sort: true,
          hidden: false,
          editable: false,
          csvExport: true,
          formatter: (cellContent, battle) => <h5 className='font-size-16 mb-1'>{battle.invoiceNo}</h5>,
          footer: ''
        },
        {
          text: 'Month',
          dataField: 'month',
          sort: true,
          hidden: false,
          editable: false,
          csvExport: true,
          formatter: (cellContent, battle) => <h5 className='font-size-16 mb-1'>{battle.month}</h5>,
          footer: ''
        },
        {
          text: 'Country',
          dataField: 'country',
          sort: true,
          csvExport: true,
          hidden: false,
          editable: false,
          csvFormatter: (cell, row, rowIndex) => `${row.country && this.getCountryName(row)}`,
          formatter: (cellContent, battle) => (
            <h5 className='font-size-16 mb-1'>
              {/* {battle.country} */}
              {battle.country && this.getCountryName(battle)}
            </h5>
          ),
          footer: ''
        },
        {
          text: 'Source',
          dataField: 'source',
          sort: true,
          hidden: false,
          csvExport: true,
          editable: false,
          formatter: (cellContent, battle) => <h5 className='font-size-16 mb-1'>{battle.source}</h5>,
          footer: ''
        },
        {
          text: 'Amount Sent',
          dataField: 'totalSaleAmount',
          sort: true,
          editable: false,
          csvExport: true,
          footer: (columnData) => (
            <div className='btn-success p-2 rounded-pill text-center'>
              <span className='font-size-16 fw-bold'>
                <NumberFormat value={columnData.reduce((acc, item) => acc + parseFloat(item), 0).toFixed(2)} displayType='text' thousandSeparator={true} prefix='$' />
              </span>
            </div>
          ),
          formatter: (cellContent, battle) => (
            <h5 className='font-size-16 mb-1'>
              <NumberFormat value={parseFloat(battle.totalSaleAmount).toFixed(2)} displayType='text' thousandSeparator={true} prefix='$' />
            </h5>
          )
        },
        {
          text: 'Amount Received',
          dataField: 'totalReceivedAmount',
          sort: true,
          hidden: false,
          csvExport: true,
          editable: false,
          formatter: (cellContent, battle) =>             
            <h5 className='font-size-16 mb-1'>
              <NumberFormat value={battle.totalReceivedAmount} displayType='text' thousandSeparator={true} prefix={battle.currAmountReceived} />
            </h5>,
          footer: ''
        }
      ]
    };
    this.getScreenHeight = this.getScreenHeight.bind(this);
    this.getCountryName = this.getCountryName.bind(this);

    // functions for filtering data
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleFilterDataSubmit = this.handleFilterDataSubmit.bind(this);
    this.resetFilterData = this.resetFilterData.bind(this);
    this.toggleStickyFilter = this.toggleStickyFilter.bind(this);

    this.groupedDataCountries = this.groupedDataCountries.bind(this);
    this.groupedDataSource = this.groupedDataSource.bind(this);
  }
  componentDidMount() {
    const { onGetNewClients } = this.props;
    onGetNewClients();
    window.addEventListener('load', this.getScreenHeight);
    window.addEventListener('click', this.getScreenHeight, { once: true });
    window.addEventListener('resize', this.getScreenHeight);
  }

  componentWillUnmount() {
    window.removeEventListener('load', this.getScreenHeight);
    window.removeEventListener('click', this.getScreenHeight);
    window.removeEventListener('resize', this.getScreenHeight);
  }
  /**
   * get screen height to set it for table
   */
  getScreenHeight = (click) => {
    let screenHeight = document.getElementById('card-section') ? document.getElementById('card-section').offsetHeight : 100;
    let filterHeight = document.getElementById('header-section') ? document.getElementById('header-section').offsetHeight + 15 : 115;
    if (click === 'click') {
      if (this.state.collapse === 1) {
        filterHeight = 54;
      } else {
        filterHeight = 177;
      }
    }
    document.querySelector('.react-bootstrap-table') &&
      document.querySelector('.react-bootstrap-table').setAttribute('style', 'height: calc(' + screenHeight + 'px - ' + filterHeight + 'px); overflow: auto;');
  };
  /**
   * @param {array} battle
   * @returns name of the country based on its value
   */
  getCountryName = (battle) => countryOptions.find((o) => o.value === battle.country).text;
  /**
   * @param {*} e
   */
  toggleStickyFilter(e) {
    let event = e.target.dataset.event;
    this.setState({
      collapse: this.state.collapse === Number(event) ? 0 : Number(event)
    });
    if (this.state.collapse === 1) {
      document.getElementById('tab').classList.remove('selected');
    } else {
      document.getElementById('tab').classList.add('selected');
    }
  }
  /**
   * Function to change selected value of state
   * @param {*} e
   * @returns state for selected value
   */
  handleFilterChange = (e) => this.setState({ [e.target.name]: e.target.value });
  /**
   * Function to reset selected filer and load current data
   * @param {*} e
   */
  resetFilterData = (e) => {
    e.preventDefault();
    window.location.reload();
  };
  /**
   * Function to filter data from selected year/month/manager
   * @param {*} e
   * @param {array} values
   * @returns filtered data
   */
  handleFilterDataSubmit = (e, values) => {
    const { onGetSelectedNewClients } = this.props;
    //  this.setState({ index: 1 })
    if (document.getElementById('create-order-btn')) {
      if (values.year === this.props.date.year && values.month === this.props.date.month) {
        document.getElementById('create-order-btn').disabled = false;
      } else {
        document.getElementById('create-order-btn').disabled = true;
      }
    }
    if (values['manager'] === '') {
      values['manager'] = null;
    }
    if (values['month'] === 'All') {
      values['month'] = null;
    }
    onGetSelectedNewClients(values);
  };

  groupedDataCountries = () => {
    const groupedDataCountries = this.props.new_clients.reduce((acc, item) => {
      const countryName = this.getCountryName(item);

      if (!acc[countryName]) {
        acc[countryName] = {
          country: countryName,
          totalOrdersByCountry: 1,
          totalSalesByCountry: item.totalSaleAmount
        };
      } else {
        acc[countryName].totalOrdersByCountry++;
        acc[countryName].totalSalesByCountry += item.totalSaleAmount;
      }

      return acc;
    }, {});
    return Object.values(groupedDataCountries);
  };
  groupedDataSource = () => {
    const groupedDataSource = this.props.new_clients.reduce((acc, item) => {
      // const countryName = this.getCountryName(item);

      if (!acc[item.source]) {
        acc[item.source] = {
          source: item.source,
          // totalOrdersByCountry: 1,
          totalSalesBySource: item.totalSaleAmount
        };
      } else {
        // acc[countryName].totalOrdersByCountry++;
        acc[item.source].totalSalesBySource += item.totalSaleAmount;
      }

      return acc;
    }, {});
    return Object.values(groupedDataSource);
  };

  render() {
    const { new_clients, period, managers, years, months, loading, profileData } = this.props;
    console.log(this.props);
    const { cards, collapse, year, month, manager } = this.state;
    const { SearchBar } = Search;
    const pageOptions = {
      sizePerPage: new_clients.length,
      sizePerPageList: [500, 1000, 1500],
      totalSize: new_clients.length,
      custom: true
    };
    const defaultSorted = [
      {
        dataField: 'month', // if dataField is not match to any column you defined, it will be ignored.
        order: 'asc' // desc or asc
      }
    ];
    return (
      <React.Fragment>
        <PageLoader progress={!loading && {"step": "Completed","time": 100}} isLoading={loading}/>
        <div className='page-content'>
          <MetaTags>
            <title>New Clients Stats</title>
          </MetaTags>
          <Container fluid>
            {profileData.permissions.includes('statisticsAnalAccess') ? (
              <>
                <Breadcrumbs title='Korupharma' breadcrumbItem='New Clients Stats' />
                <Row id='card-section'>
                  <Col lg='6'>
                    <Card>
                      <CardBody className='cardBodySticky'>
                        <PaginationProvider pagination={paginationFactory(pageOptions)} keyField='id' columns={this.state.NewClientsListColumns} data={new_clients}>
                          {({ paginationProps, paginationTableProps }) => (
                            <ToolkitProvider
                              keyField='id'
                              columns={this.state.NewClientsListColumns}
                              data={new_clients}
                              search
                              columnToggle
                              exportCSV={{
                                fileName: 'New_Clients.csv'
                              }}
                            >
                              {(toolkitprops) => (
                                <React.Fragment>
                                  <div className='header-section' id='header-section'>
                                    {cards.map((index) => {
                                      return (
                                        <Card style={{ marginBottom: '1rem' }} key={index} id='tab' className='selected'>
                                          <CardHeader
                                            id='tab_header'
                                            onClick={(event) => {
                                              this.toggleStickyFilter(event);
                                              this.getScreenHeight('click');
                                            }}
                                            data-event={index}
                                          >
                                            {/* <i className={collapse === 1 ? "mdi mdi-chevron-down mdi-24px" : "mdi mdi-chevron-right mdi-24px"}/>{collapse === 1 ? "Hide" : "Show"}  */}
                                          </CardHeader>
                                          <Collapse isOpen={collapse === index}>
                                            <CardBody>
                                              <Row className='mb-2 searchBar'>
                                                <Col md='2' sm='12' className='d-flex'>
                                                  <div className='search-box ms-2 mb-2 me-5 d-inline-block '>
                                                    <div className='position-relative'>
                                                      <SearchBar {...toolkitprops.searchProps} />
                                                      <i className='bx bx-search-alt search-icon' />
                                                    </div>
                                                  </div>
                                                </Col>
                                                <Col md='5' sm='12'>
                                                  <AvForm className='d-flex' id='filter-date-form' onValidSubmit={this.handleFilterDataSubmit}>
                                                    <FormGroup className='me-2'>
                                                      <AvField type='select' name='year' id='year' className='form-select' onChange={this.handleFilterChange} value={period ? period.year : year}>
                                                        {years.map((year, index) => (
                                                          <option key={index} className='fw-bold fs-5' value={year}>
                                                            {year}
                                                          </option>
                                                        ))}
                                                      </AvField>
                                                    </FormGroup>
                                                    <FormGroup className='me-2'>
                                                      <AvField type='select' name='month' className='form-select' onChange={this.handleFilterChange} value={period ? period.month : month}>
                                                        {months.map((month, index) => (
                                                          <option key={index} className='fw-bold fs-5'>
                                                            {month.month}
                                                          </option>
                                                        ))}
                                                      </AvField>
                                                    </FormGroup>
                                                    <FormGroup className='me-2'>
                                                      <AvField type='select' name='manager' className='form-select' onChange={this.handleFilterChange} value={manager}>
                                                        <option value=''>All</option>
                                                        {managers.map((manager, index) => (
                                                          <option key={index} className='fw-bold fs-5' value={manager._id}>
                                                            {manager.fname} {manager.sname}
                                                          </option>
                                                        ))}
                                                      </AvField>
                                                    </FormGroup>
                                                    <FormGroup className='me-2'>
                                                      <button className='btn btn-success save-user' id='dblclick'>
                                                        Filter
                                                      </button>
                                                    </FormGroup>
                                                    <FormGroup className=''>
                                                      <button type='reset' onClick={this.resetFilterData} className='btn btn-primary save-user'>
                                                        Resets
                                                      </button>
                                                    </FormGroup>
                                                  </AvForm>
                                                </Col>
                                                <Col md='5 ps-3 d-flex justify-content-between'>
                                                  <MyExportCSV {...toolkitprops.csvProps} />
                                                </Col>
                                              </Row>
                                            </CardBody>
                                          </Collapse>
                                        </Card>
                                      );
                                    })}
                                  </div>
                                  <Row id='table-section'>
                                    <BootstrapTable
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      defaultSorted={defaultSorted}
                                      classes={'table align-middle table-nowrap'}
                                      headerClasses='header-class is-sticky-hdr'
                                      id='tableScroll'
                                      bordered={true}
                                      // striped={true}
                                      filter={filterFactory()}
                                      responsive
                                    />
                                  </Row>
                                </React.Fragment>
                              )}
                            </ToolkitProvider>
                          )}
                        </PaginationProvider>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg='6'>
                    <BarChartComp props={this.props} groupedDataCountries={this.groupedDataCountries()} groupedDataSource={this.groupedDataSource()} />
                  </Col>
                </Row>
              </>
            ) : (
              <Alert color='danger'>You do not have access to this page.</Alert>
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

NewClientsList.propTypes = {
  new_clients: PropTypes.array,
  onGetNewClients: PropTypes.func
};

const mapStateToProps = ({ stats }) => ({
  new_clients: stats.new_clients,
  managers: stats.managers,
  years: stats.years,
  months: stats.months,
  period: stats.period,
  loading: stats.loading
});

const mapDispatchToProps = (dispatch) => ({
  onGetNewClients: () => dispatch(getNewClients()),
  onGetSelectedNewClients: (id) => dispatch(getSelectedNewClients(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NewClientsList));
